import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfilePreviewComponent } from './profile-preview.component';

import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { WrapFnPipe } from '../../pipes';

@NgModule({
  declarations: [ProfilePreviewComponent],
  imports: [
    CommonModule,
    NzAvatarModule,
    NzDropDownModule,
    WrapFnPipe,
    TranslateModule,
  ],
  exports: [ProfilePreviewComponent],
})
export class ProfilePreviewModule {}
